export function QuickStart() {
  return (
    <section
      id="quick-start"
      className="scroll-mt-16 w-full py-20 px-6 bg-background"
    >
      <div className="mx-auto max-w-3xl space-y-8">
        <div className="text-center space-y-3">
          <h2 className="text-3xl font-bold tracking-tight md:text-4xl text-foreground">
            Quick start
          </h2>
        <p className="text-muted-foreground text-lg">
          Create a new app in one command. Mark pages with{" "}
          <code className="rounded bg-muted px-1.5 py-0.5 font-mono text-sm text-foreground">
            export const ssr = {"{ mode: \"ssg\" }"}
          </code>{" "}
          to pre-render them at build time.
        </p>
        </div>
        <div className="rounded-xl border border-border bg-card overflow-hidden shadow-sm">
          <div className="px-4 py-2 border-b border-border bg-muted/50">
            <span className="text-xs font-medium text-muted-foreground uppercase tracking-wider">
              Terminal
            </span>
          </div>
          <pre className="p-6 overflow-x-auto text-sm leading-relaxed font-mono text-foreground">
            <code>{`npx create-landrr-app my-landing-page
cd my-landing-page
npm run dev`}</code>
          </pre>
        </div>
        <p className="text-center text-sm text-muted-foreground">
          Then open{" "}
          <code className="rounded bg-muted px-1.5 py-0.5 font-mono text-foreground">
            http://localhost:3000
          </code>
        </p>
      </div>
    </section>
  );
}
